"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _PostItCard = require("./PostItCard.styles");
var _theme = require("../utils/theme");
var _date = require("@qwkin/date");
var PostItCard = function PostItCard(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 250 : _ref$size,
    _ref$date = _ref.date,
    date = _ref$date === void 0 ? new Date() : _ref$date;
  return /*#__PURE__*/_react["default"].createElement(_PostItCard.PostItContainer, {
    size: size,
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_PostItCard.PostItHeader, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_PostItCard.PostItHeaderDetail, null, (0, _date.formatDateToMonthday)(date)), /*#__PURE__*/_react["default"].createElement(_PostItCard.PostItHeaderDetail, null, (0, _date.formatDateToWeekday)(date))), /*#__PURE__*/_react["default"].createElement(_PostItCard.PostItChildrenContainer, null, children));
};
var _default = exports["default"] = PostItCard;